import { render, staticRenderFns } from "./exchangeApis.vue?vue&type=template&id=3a4b5947&"
import script from "./exchangeApis.vue?vue&type=script&lang=js&"
export * from "./exchangeApis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports